module.exports = __webpack_public_path__ + "media/mypage/images/icons/icon_history-d01de660778a2d5e13354daa896b2595.png";